module.exports = __webpack_public_path__ + "img/modular_settlement_examine_yellow@2x.3dc2bc69.png";